module.exports = __webpack_public_path__ + "img/[摊手].a6e5776f.svg";